import React from 'react';
import PropTypes from 'prop-types';
import Comment from './Comment';

const CommentsList = ({ comments, loggedInUser, toggleLike, submitReply, deleteComment, reportComment, deleteReply, reportReply }) => {
  let commentsList;
  if (comments.length) {
    commentsList = (
      <ul className="comments-list faux-list no-margin-list">
        {comments.map(comment => (
          <li key={comment.id}>
            <Comment
              comment={comment}
              loggedInUser={loggedInUser}
              toggleLike={toggleLike}
              submitReply={submitReply}
              deleteComment={deleteComment}
              reportComment={reportComment}
              deleteReply={deleteReply}
              reportReply={reportReply}
            />
          </li>
        ))}
      </ul>
    );
  } else {
    commentsList = <div className="no-comments-message h2 text-grey">Write a comment to get the conversation started...</div>;
  }

  return (
    <div>
      {commentsList}
    </div>
  );
};

CommentsList.propTypes = {
  comments: PropTypes.array,
  loggedInUser: PropTypes.object,
  toggleLike: PropTypes.func,
  submitReply: PropTypes.func,
  deleteComment: PropTypes.func,
  reportComment: PropTypes.func,
  deleteReply: PropTypes.func,
  reportReply: PropTypes.func,
};

export default CommentsList;



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/CommentsList.js